<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button
          class="btn btn-fill btn-icon"
          @click="minimizeSidebar"
        >
          <i :class="$sidebar.isMinimized ? 'ti-angle-right' : 'ti-angle-left'" />
        </button>
      </div>
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          :class="{toggled: $sidebar.showSidebar}"
          @click="toggleSidebar"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1" />
          <span class="icon-bar bar2" />
          <span class="icon-bar bar3" />
        </button>
        <a class="navbar-brand">{{ $route.meta.title }}</a>
      </div>
      <div class="collapse navbar-collapse">
        <!-- // TODO: put it back when approved -->
        <!-- <form
          class="navbar-form navbar-left navbar-search-form"
          role="search"
        >
          <div class="input-group">
            <input
              type="text"
              value=""
              class="form-control"
              placeholder="Search..."
            >
            <span class="input-group-addon"><i class="fa fa-search" /></span>
          </div>
        </form> -->
        <!-- <ul class="nav navbar-nav navbar-right">
          <li class="open">
            <router-link
              to="/stats"
              class="dropdown-toggle btn-magnify"
              data-toggle="dropdown"
            >
              <i class="ti-panel" />
              <p>Stats</p>
            </router-link>
          </li>
          <drop-down
            tag="li"
            title="5"
            icon="ti-bell"
          >
            <li><a href="#">Notification 1</a></li>
            <li><a href="#">Notification 2</a></li>
            <li><a href="#">Notification 3</a></li>
            <li><a href="#">Notification 4</a></li>
            <li><a href="#">Another notification</a></li>
          </drop-down>
          <li>
            <router-link
              to="/overview"
              class="btn-rotate"
            >
              <i class="ti-settings" />
            </router-link>
          </li>
        </ul> -->
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    data () {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      }
    }
  }

</script>
<style>

</style>
